import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';
import { EGroupCheckboxState, calculateConsentGroupState, getConsentGroup, interpolateConsent, MINIMUM_AGE } from '@gig/magic-account-types';

/**
 * Component to display the marketing components in the sign up.
 */
var NestedMarketingConsentsComponent = /** @class */ (function (_super) {
    __extends(NestedMarketingConsentsComponent, _super);
    function NestedMarketingConsentsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.consentTouched = {};
        _this.accordionState = {};
        return _this;
    }
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "groupedConsents", {
        get: function () {
            if (!this.valueObject) {
                return {};
            }
            return this.splitTermsAndMarketingConsents(this.valueObject);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "termsConsents", {
        get: function () {
            var _a;
            return ((_a = this.groupedConsents) === null || _a === void 0 ? void 0 : _a.terms) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "marketingConsents", {
        get: function () {
            var _a;
            return ((_a = this.groupedConsents) === null || _a === void 0 ? void 0 : _a.marketing) || [];
        },
        enumerable: false,
        configurable: true
    });
    NestedMarketingConsentsComponent.prototype.getSubMarketingConsents = function (index) {
        return this.groupedConsents.marketing[index].subConsents || [];
    };
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "isTermsGroupChecked", {
        get: function () {
            return this.termsGroupState === EGroupCheckboxState.CHECKED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "isMarketingGroupChecked", {
        get: function () {
            return this.marketingGroupState === EGroupCheckboxState.CHECKED;
        },
        enumerable: false,
        configurable: true
    });
    NestedMarketingConsentsComponent.prototype.isMarketingSubGroupChecked = function (index) {
        return (this.marketingSubGroupState(index) === EGroupCheckboxState.CHECKED);
    };
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "isTermsGroupIndeterminate", {
        get: function () {
            return this.termsGroupState === EGroupCheckboxState.INDETERMINATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "isMarketingGroupIndeterminate", {
        get: function () {
            return this.marketingGroupState === EGroupCheckboxState.INDETERMINATE;
        },
        enumerable: false,
        configurable: true
    });
    NestedMarketingConsentsComponent.prototype.isMarketingSubGroupIndeterminate = function (index) {
        return (this.marketingSubGroupState(index) ===
            EGroupCheckboxState.INDETERMINATE);
    };
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "termsGroupState", {
        get: function () {
            return calculateConsentGroupState(this.termsConsents);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NestedMarketingConsentsComponent.prototype, "marketingGroupState", {
        get: function () {
            return calculateConsentGroupState(this.marketingConsents);
        },
        enumerable: false,
        configurable: true
    });
    NestedMarketingConsentsComponent.prototype.marketingSubGroupState = function (index) {
        return calculateConsentGroupState(this.marketingConsents[index].subConsents);
    };
    NestedMarketingConsentsComponent.prototype.subMarketingGroupState = function (index) {
        return calculateConsentGroupState(this.getSubMarketingConsents(index));
    };
    NestedMarketingConsentsComponent.prototype.triggerValidationOnNextStep = function () {
        if (!this.nextStepBlocked) {
            return;
        }
        this.touchConsents();
    };
    NestedMarketingConsentsComponent.prototype.toggleTermsGroup = function () {
        this.touchConsents();
        this.toggleGroup(this.termsConsents, this.termsGroupState);
    };
    NestedMarketingConsentsComponent.prototype.toggleAccordionState = function (accordionState, index) {
        var _a;
        this.accordionState = __assign(__assign({}, this.accordionState), (_a = {}, _a[index] = accordionState, _a));
    };
    NestedMarketingConsentsComponent.prototype.touchConsents = function () {
        var _this = this;
        this.termsConsents.forEach(function (consent) {
            _this.consentTouched[consent.consentId] = true;
        });
    };
    NestedMarketingConsentsComponent.prototype.toggleMarketingGroup = function () {
        this.touchMarketingConsents();
        this.toggleGroup(this.marketingConsents, this.marketingGroupState);
    };
    NestedMarketingConsentsComponent.prototype.toggleSubMarketingGroup = function (index) {
        this.touchMarketingConsents();
        this.toggleGroup(this.getSubMarketingConsents(index), this.subMarketingGroupState(index));
    };
    NestedMarketingConsentsComponent.prototype.touchMarketingConsents = function () {
        var _this = this;
        this.marketingConsents.forEach(function (consent) {
            _this.consentTouched[consent.consentId] = true;
            if (consent.subConsents) {
                consent.subConsents.forEach(function (sub) {
                    _this.consentTouched[sub.consentId] = true;
                });
            }
        });
    };
    NestedMarketingConsentsComponent.prototype.toggleGroup = function (consents, groupState) {
        var toggledState = groupState !== EGroupCheckboxState.CHECKED;
        var updateConsents = function (consentList) {
            return consentList.reduce(function (acc, consent) {
                acc[consent.consentId] = toggledState;
                if (consent.subConsents && consent.subConsents.length > 0) {
                    var subConsentChanges = updateConsents(consent.subConsents);
                    Object.assign(acc, subConsentChanges);
                }
                return acc;
            }, {});
        };
        var modelChanges = updateConsents(consents);
        this.reconciliateModel(modelChanges);
    };
    NestedMarketingConsentsComponent.prototype.addToGroupedConsent = function (consentGroups, consentGroup, consent, prepend) {
        if (prepend === void 0) { prepend = false; }
        if (consentGroups.hasOwnProperty(consentGroup)) {
            prepend
                ? consentGroups[consentGroup].unshift(consent)
                : consentGroups[consentGroup].push(consent);
        }
        else {
            consentGroups[consentGroup] = [consent];
        }
    };
    NestedMarketingConsentsComponent.prototype.splitTermsAndMarketingConsents = function (consents) {
        var _this = this;
        var consentGroups = {};
        consents
            .filter(function (consent) { return !!consent.consentContents; })
            .forEach(function (consent) {
            var consentGroup = getConsentGroup(consent.name);
            var consentContent = consent;
            if (consent.name === ConsentName.TERMS) {
                consentContent = interpolateConsent(consent, 'minimumAge', MINIMUM_AGE);
                _this.addToGroupedConsent(consentGroups, consentGroup, consentContent, true);
            }
            else {
                _this.addToGroupedConsent(consentGroups, consentGroup, consentContent);
            }
        });
        return consentGroups;
    };
    NestedMarketingConsentsComponent.prototype.onChildrenChange = function (event, consent) {
        var _a;
        var checked = event.detail[0];
        this.reconciliateModel((_a = {}, _a[consent.consentId] = checked, _a));
    };
    NestedMarketingConsentsComponent.prototype.reconciliateModel = function (changes) {
        // create a clone of the field value
        var modelClone = JSON.parse(JSON.stringify(this.valueObject));
        // Recursive function to update consents and their sub-consents
        var applyChanges = function (consentList) {
            return consentList.map(function (consent) {
                var updatedConsent = changes.hasOwnProperty(consent.consentId)
                    ? __assign(__assign({}, consent), { consented: changes[consent.consentId] }) : __assign({}, consent);
                if (updatedConsent.subConsents &&
                    updatedConsent.subConsents.length > 0) {
                    updatedConsent.subConsents = applyChanges(updatedConsent.subConsents);
                }
                return updatedConsent;
            });
        };
        var modelChanges = applyChanges(modelClone);
        this.emitStandAloneChange(modelChanges, true);
    };
    NestedMarketingConsentsComponent.prototype.hasErrorConsents = function (consent) {
        return (this.consentTouched[consent.consentId] &&
            consent.isMandatory &&
            !consent.consented);
    };
    NestedMarketingConsentsComponent.prototype.markConsentAsTouched = function (consent) {
        this.consentTouched[consent.consentId] = true;
    };
    NestedMarketingConsentsComponent.prototype.areConsentsValid = function (consents) {
        return !consents.find(function (consent) { return consent.isMandatory && !consent.consented; });
    };
    NestedMarketingConsentsComponent.prototype.emitStandAloneChange = function (value, touched) {
        return {
            value: value,
            isValid: this.areConsentsValid(value),
            touched: touched,
        };
    };
    NestedMarketingConsentsComponent.prototype.onConsentsChange = function (newConsents) {
        if (newConsents && newConsents.length > 0) {
            this.emitStandAloneChange(newConsents, false);
        }
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NestedMarketingConsentsComponent.prototype, "collapsibleMarketingPreferences", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NestedMarketingConsentsComponent.prototype, "nextStepBlocked", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], NestedMarketingConsentsComponent.prototype, "valueObject", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], NestedMarketingConsentsComponent.prototype, "consents", void 0);
    __decorate([
        Watch('nextStepBlocked', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NestedMarketingConsentsComponent.prototype, "triggerValidationOnNextStep", null);
    __decorate([
        Emit('stand-alone-change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], NestedMarketingConsentsComponent.prototype, "emitStandAloneChange", null);
    __decorate([
        Watch('consents', { immediate: true, deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NestedMarketingConsentsComponent.prototype, "onConsentsChange", null);
    NestedMarketingConsentsComponent = __decorate([
        Component({
            name: 'corex-nested-marketing-preferences',
        })
    ], NestedMarketingConsentsComponent);
    return NestedMarketingConsentsComponent;
}(Mixins(MagicConfigMixin)));

export default NestedMarketingConsentsComponent;
